import cs from './cs/strings.json';
import en from './en/strings.json';

export default {
    cs,
    en
}